import { Component } from '@angular/core';

@Component({
    selector: 'app-payment-mode',
    templateUrl: './payment-mode.component.html',
    styleUrls: ['./payment-mode.component.scss'],
    standalone: false
})
export class PaymentModeComponent {

}
